import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const MessageSigningRequestPropsSchema = z.object({
  message: z.instanceof(HexNumber),
})

type MessageSigningRequestProps = z.infer<
  typeof MessageSigningRequestPropsSchema
>

export class MessageSigningRequest extends ValueObject<MessageSigningRequestProps> {
  public getValue(): HexNumber {
    return this.props.message
  }

  public toBuffer(): Buffer {
    return this.props.message.toBuffer()
  }

  public static create(message: HexNumber): MessageSigningRequest {
    const validatedProps = MessageSigningRequestPropsSchema.parse({ message })
    return new MessageSigningRequest(validatedProps)
  }
}
